document.addEventListener('DOMContentLoaded', function() {
    // Color deseado para la barra de navegación
    var color = '#bb9118';

    // Meta tag para Android
    var themeColorMetaTag = document.createElement('meta');
    themeColorMetaTag.setAttribute('name', 'theme-color');
    themeColorMetaTag.setAttribute('content', color);
    document.head.appendChild(themeColorMetaTag);

    // Meta tag para iOS
    var appleStatusBarMetaTag = document.createElement('meta');
    appleStatusBarMetaTag.setAttribute('name', 'apple-mobile-web-app-status-bar-style');
    appleStatusBarMetaTag.setAttribute('content', 'black-translucent');
    document.head.appendChild(appleStatusBarMetaTag);

    // Meta tag para Windows Phone
    var msNavButtonColorMetaTag = document.createElement('meta');
    msNavButtonColorMetaTag.setAttribute('name', 'msapplication-navbutton-color');
    msNavButtonColorMetaTag.setAttribute('content', color);
    document.head.appendChild(msNavButtonColorMetaTag);
});
